import styled from 'styled-components';
import { device } from '@src/common/breakpoints';

const mediaQueries = `
  ${device.smallTablet} {
    max-width: 540px;
  }

  ${device.mediumTablet} {
    max-width: 720px;
  }

  ${device.large} {
    max-width: 960px;
  }

  ${device.extraLarge} {
    max-width: 1140px;
  }
`;

export const Container = styled('div')<{ fluid?: boolean }>`
  width: 100%;
  margin-right: auto;
  margin-left: auto;
  padding-left: 10px;
  padding-right: 10px;
  box-sizing: border-box;

  ${(props) => (!props.fluid ? mediaQueries : null)};
`;

export default Container;
